import React from 'react';
import {AssetService} from '@taopix/taopix-core/dist/types/types';
import {AssetServiceDialogProps} from './AssetServiceDialog';
import InternalAssetService from './InternalAssetService';
import RemoteAssetService from './RemoteAssetService';
import LibraryLink from './LibraryLink/LibraryLink';

export type AssetServiceFactoryProps = AssetServiceDialogProps & {
  service?: AssetService | null;
  closeEvent: () => void;
};

/**
 * Returns the correct asset service component based on the service passed in
 *
 * @param props
 * @returns
 */
const AssetServiceFactory = (props: AssetServiceFactoryProps) => {
  const {service, ...rest} = props;

  // if no service is passed in, return null
  if (!service) {
    return null;
  }
  // any service with an id < 0 is an internal service
  if (service?.id < 0) {
    return <InternalAssetService assetService={service} {...rest} />;
  }

  // any service with a code in this list is a remote service
  if (['%FACEBOOK%', '%INSTAGRAM%', '%GOOGLEPHOTOS%', '%FLICKR%'].includes(service?.code)) {
    return <RemoteAssetService assetService={service} {...rest} />;
  }

  // any other service is a library link
  return <LibraryLink assetService={service} {...rest} />;
};

export default AssetServiceFactory;
